import IntercomService from './IntercomService';
import Cohere from 'cohere-js';
import posthog from 'posthog-js';
import { getImpersonatorUser } from '../thunks/session_thunks';
import { getSubscriptionPayload, nullSafeGet } from './DataAccessUtils';
import { ROLE_TYPES } from './DataConstants';
import { updateWebPushNotificationForLogIn } from '../thunks/web_push_notification_thunks';
import { getBrowserAndDeviceInfo, isInternalTech } from './AuthUtils';

const publicVapidKey =
	'BDOr4x2P5UsBc4BIgFeObHru7v8KbCzjRdFvnBkOAqfaWciEtfNmX7ziTmV7G3qpYQsQm2Pi_mmLSERqivkGnos';

async function registerPush(userType) {
	const TWENTY_FOUR_HOURS_IN_MS = 24 * 60 * 60 * 1000;

	//Call register Push once again after 24 hrs if the session is still online
	setTimeout(() => {
		registerPush(userType);
	}, TWENTY_FOUR_HOURS_IN_MS);

	if (!('serviceWorker' in navigator)) {
		console.error('Service workers are not supported in this browser.');
		return;
	}

	const register = await navigator.serviceWorker.register('/sw.js', { scope: '/' });

	const permission = await Notification.requestPermission();
	if (permission !== 'granted') {
		console.error('Notification permission denied.');
		return;
	}

	const subscription = await register.pushManager.getSubscription();

	if (subscription) {
		// console.log('Unsubscribing from existing push subscription');
		// await subscription.unsubscribe();

		const payload = getSubscriptionPayload(subscription);

		updateWebPushNotificationForLogIn(userType)({
			...payload,
			deviceDetails: getBrowserAndDeviceInfo(),
		});
	} else {
		// Now subscribe again with the new key
		const newSubscription = await register.pushManager.subscribe({
			userVisibleOnly: true,
			applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
		});

		const payload = getSubscriptionPayload(newSubscription);

		updateWebPushNotificationForLogIn(userType)({
			...payload,
			deviceDetails: getBrowserAndDeviceInfo(),
		});
	}
}

function urlBase64ToUint8Array(base64String) {
	const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
	const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
	const rawData = atob(base64);
	return new Uint8Array([...rawData].map((char) => char.charCodeAt(0)));
}
class ThirdPartyService {
	// TODO: init method should also go here. consolidation

	boot({ user }): void {
		let userObj = user;
		const isImpersonationMode = !!localStorage.getItem('impersonation');

		if (isImpersonationMode) {
			userObj = getImpersonatorUser();
		}
		// posthog-js
		posthog.identify(userObj.contact.email, {
			company: nullSafeGet('contact.facility.name', userObj),
			userType: nullSafeGet('user.userType', userObj),
			email: nullSafeGet('contact.email', userObj),
			roles: nullSafeGet('user.roles', userObj),
			isPaying:
				nullSafeGet('user.userType', userObj) === ROLE_TYPES.SUPPLIER
					? nullSafeGet('contact.facility.supplierCompany.isPayingSupplier', userObj)
					: nullSafeGet('contact.facility.buyerCompany.supplierManagedCompany', userObj),
			isInternalTeam: isInternalTech(nullSafeGet('contact', userObj)),
		});

		IntercomService.boot({ user: { ...userObj.user, ...userObj.contact } });
		window['Canny']('identify', {
			appID: '60679823a8497c443e504ecf',
			user: {
				name: userObj.contact.nameGiven + ' ' + userObj.contact.nameFamily,
				email: userObj.contact.email,
				id: userObj.contact.email,
			},
		});
		Cohere.identify(userObj.contact.email, {
			displayName: userObj.contact.nameGiven + ' ' + userObj.contact.nameFamily,
			email: userObj.contact.email,
		});

		//Reginster for push notification and update details to BE
		registerPush(nullSafeGet('contact.contactType', userObj));
	}
}

export default new ThirdPartyService();
